import {
  Component,
  computed,
  EventEmitter,
  Input,
  Output,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'smw-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.less'],
})
export class StepperComponent {
  private _currentStepNumber: WritableSignal<number> = signal(0);

  @Input() totalStepNumber = 2;
  @Output() currentStepChanged = new EventEmitter<number>();

  currentStepNumber: Signal<number> = computed(() => this._currentStepNumber());
  stepArray = computed(() => Array.from({ length: this.totalStepNumber }, (_, i) => i));

  /** Made available for others component to update the current exercice step */
  updateStepNumber(stepNumber: number): void {
    this._currentStepNumber.set(stepNumber);
    this.currentStepChanged.emit(stepNumber);
  }
}
